/* eslint-disable @next/next/no-img-element */
import "./earnRewardItem.scss";
import GiftModel from "./giftModel";
import { Helmet } from "react-helmet";
import TermsDialog from "./termsDialog";
import ShareDialog from "./shareDialog";
import ConfirmShareDialog from "./confirmShareDialog";
import style from "./index.module.scss";
import RewardDetails from "./rewardDetails";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import  CodeTipIcon  from "../assets/invite-code-tip.svg";
import  RuleIcon  from "../assets/invite-rule.svg";
import  PolitelyIcon  from "../assets/invite-politely.svg";
import { InviteActivityType } from "@/app/csr-src/apis/invitePolitely/invitePolitely.interface";
import JDIPrice from "@/common-components-src/js/price/index";
import JDILogin from "@/common-components-src/js/newlogin/index.newlogin";
import UKToast from "@/common-components-src/components/UKToast/index";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";
import {
  getActivityDetailApi,
  getActivityGiftApi,
  getCheckshareActivityApi,
} from "@/app/csr-src/apis/invitePolitely/invitePolitely.api";
import {
  EarnRewardLeftItem,
  EarnRewardRightItem,
  EarnRewardStep1Item,
  EarnRewardStep2Item,
  EarnRewardStep3Item,
  YourRewardItem,
} from "./earnRewardItem";
import to from "await-to-js";
import { sendPv, sendClickTrack } from "@/tracks/25158"

interface TaskProcessProp {
  success: number;
  pending: number;
  coupon: number;
  bonus: string;
}

interface GiftDataProp {
  quota: string;
  discount: string;
  isFreight: boolean;
  receiveQty: number;
}

interface ActivityDataProp {
  inviteCode: string;
  activityId: string;
  activityType: number;
  activityTerms: string;
  taskProcess: TaskProcessProp;
  inviterNum: number;
  inviterTxt: string;
  inviterAward: string;
  invitedAward: string;
  expireTime: string;
  inviterCoupon: any;
}

export default function InvitePolitely() {
  const [giftData, setGiftData] = useState<GiftDataProp | null>();
  const [activityData, setActivityData] = useState<ActivityDataProp | null>();
  const [openGift, setOpenGift] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [openShare, setOpenshare] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [openConfirmShare, setOpenConfirmShare] = useState(false);
  const [confirmShareMsg, setConfirmShareMsg] = useState("");
  const [currency, setCurrency] = useState<string>("£");
  const [shareInfo, setShareInfo] = useState<any>({});
  const [taskProcess, setTaskProcess] = useState<any>({});
  const [isCodeType, setIsCodeType] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  const onOpenTerms = () => {
    setOpenTerms(true);
  };

  const onCloseTerms = () => {
    setOpenTerms(false);
  };

  const onCloseGift = () => {
    setOpenGift(false);
    checkActivity();
  };

  const onCloseShare = () => {
    setOpenshare(false);
  };

  const onOpenShare = () => {
    setOpenshare(true);
    // checkActivity()
  };

  const onCloseConfirmShare = () => {
    setOpenConfirmShare(false);
    // 打开分享弹窗
    setOpenshare(true);
  };

  const shareCopyLink = () => {
    UKToast.show({
      content: "Copied succeeded",
      icon: "success",
    });
  };

  const checkActivity = async () => {
    const coupon = activityData?.inviterCoupon;
    sendClickTrack.Activity_Yqyl_Invite({
      batchId: String(coupon?.batchId) || "-100",
      use_threshold: coupon?.quota || "-100",
      couponType: String(coupon?.couponType) as any || "-100",
      couponSave: coupon?.discount || "-100",
      couponId: coupon?.couponId || "-100",
      couponNum: "-100",  
    });
    try {
      const res = await getCheckshareActivityApi(activityData?.activityId as string);
      if (res?.code === "200" && res?.data) {
        onOpenShare();
      } else if (res?.code === "400") {
        JDILogin.getInstance().openLoginDialog();
      } else if (res?.code === "2004") {
        // 打开二次确认
        setOpenConfirmShare(true);
        setConfirmShareMsg(res.msg);
      } else {
        UKToast.show({
          content: res?.msg,
          icon: "success",
        });
      }
    } catch {
      console.log("Net error");
    }
  };

  const getActivityDetail = async () => {
    const [err, res] = await to(getActivityDetailApi());
    if(err){
      setIsLoading(false);
      setIsError(true);
    }
    else{
      setIsLoading(false);
      setIsError(false);
      if (res && res.code == "200") {
        initActivityData(res);
        setIsClosed(false);
      }
      else{
        setIsClosed(true);
      }
    }
    sendPv.Activity_Yqyl({ invite_code: res?.data?.inviteCode || "" });
  };

  const initActivityData = (res: any) => {
    const newActivityData: any = {};
    const awardRule = res?.data?.activityAwardRule;
    const inviterRules = awardRule?.inviterRules[0];
    newActivityData.inviteCode = res?.data.inviteCode;
    newActivityData.activityId = res?.data.activityId;
    newActivityData.activityType = res?.data.activityType;
    newActivityData.activityTerms = res?.data.activityTerms;
    newActivityData.taskProcess = res?.data.taskProcess;
    newActivityData.expireTime = res?.data.endTimeStr;
    newActivityData.inviterNum = inviterRules?.rewardConditions;
    newActivityData.inviterTxt = inviterRules?.rewardConditions == 1 ? "Friend" : "Friends";
    newActivityData.inviterAward = inviterRules?.awardWorth;
    newActivityData.invitedAward = awardRule?.invitedRules[0]?.awardWorth;
    newActivityData.inviterCoupon = awardRule?.inviterRules[0]?.activityAwards[0]?.coupon;
    newActivityData.invitedCoupon = awardRule?.invitedRules[0]?.activityAwards[0]?.coupon;
    const { currencySymbol, activityAwardRule, taskProcess, activityShareUrl, shareTitle } = res.data;

    setCurrency(res?.data.currencySymbol);
    setActivityData(newActivityData);
    setIsCodeType(res?.data.activityType === InviteActivityType.InvitePolityCode);
    // 取分享-优惠券信息
    setShareInfo({
      activityAwardRule,
      activityShareUrl,
      shareTitle,
      currencySymbol,
    });
    // 取奖励明细-优惠券信息
    setTaskProcess(taskProcess);
    // 获取奖励弹框数据
    getActivityGift(res?.data?.activityId);
  }

  const getActivityGift = async (activityId: string) => {
    const res = await getActivityGiftApi(activityId);
    if (res && res.code == "200" && !!res.data.length) {
      const coupon = res.data[0]?.coupon;
      const data = {
        quota: coupon?.quota,
        discount: coupon?.discount,
        isFreight: coupon?.couponType == 2,
        receiveQty: res.data[0]?.receiveQty,
      };
      setGiftData(data);
      setOpenGift(true);
    }
  };

  useEffect(() => {
    getActivityDetail();
  }, []);

  if (isLoading) {
    return <UKPageLoading />;
  }

  function EarnRewardCommonContent() {
    return (
      <div className={style.earn_reward}>
        <div className={style.get_reward}>
          <div className={style.reward_title}>How to earn reward?</div>
          <div className={style.reward_detail}>
            <EarnRewardLeftItem
              inviterNum={activityData?.inviterNum}
              inviterTxt={activityData?.inviterTxt}
              currency={currency}
              awardTxt={activityData?.inviterAward}
            />
            <EarnRewardRightItem currency={currency} awardTxt={activityData?.invitedAward} />
          </div>
        </div>
        <button className={style.invite_friends} onClick={checkActivity}>
          Invite Friends Now
        </button>
        <RuleIcon />
      </div>
    );
  }

  function EarnRewardCodeContent() {
    return (
      <div className={style.earn_code_reward}>
        <div className={style.get_reward}>
          <div className={style.reward_title}>How to earn rewards?</div>
          <div className={style.reward_detail}>
            <EarnRewardStep1Item />
            <EarnRewardStep2Item
              currency={currency}
              activityData={activityData}
              awardTxt={activityData?.invitedAward}
            />
            <EarnRewardStep3Item
              currency={currency}
              activityData={activityData}
              awardTxt={activityData?.inviterAward}
            />
          </div>
        </div>
        <div className={style.copy_code}>
          <div className={style.code_frame}>{activityData?.inviteCode}</div>
          <CopyToClipboard
            text={activityData?.inviteCode || ""}
            onCopy={shareCopyLink}
          >
            <div className={style.copy_frame}>Copy</div>
          </CopyToClipboard>
        </div>
        <button className={style.invite_friends} onClick={checkActivity}>
          Share
        </button>
      </div>
    );
  }

  function YourRewardCommonContent() {
    return (
      <div className={style.your_reward}>
        <div className={style.reward_title}>Your rewards</div>
        <div className={style.reward_frame}>
          <YourRewardItem num={activityData?.taskProcess?.success || 0} desc="Success" />
          <YourRewardItem num={activityData?.taskProcess?.pending || 0} desc="Pending " />
          <YourRewardItem num={activityData?.taskProcess?.coupon || 0} desc="Coupon" />
          <div className="reward_item">
            <JDIPrice
              uiType={1}
              symbol={currency}
              price={activityData?.taskProcess?.bonus as string}
              containerStyle={{
                fontSize: "24px",
                lineHeight: "24px",
              }}
              integerStyle={{
                fontSize: "24px",
                lineHeight: "24px",
                height: "24px",
              }}
            />
            <div className={style.reward_desc}>Bonus</div>
          </div>
        </div>
      </div>
    );
  }

  function YourRewardCodeContent() {
    return (
      <div className={style.your_reward}>
        <div className={style.reward_title}>Your rewards</div>
        <div className={style.code_reward_frame}>
          <YourRewardItem
            num={activityData?.taskProcess?.coupon || 0}
            desc="Coupon count"
            showLine={false}
          />
          <div className={style.code_line} />
          <div className="reward_item">
            <JDIPrice
              uiType={1}
              symbol={currency}
              price={activityData?.taskProcess?.bonus as string}
              containerStyle={{
                fontSize: "24px",
                lineHeight: "24px",
              }}
              integerStyle={{
                fontSize: "24px",
                lineHeight: "24px",
                height: "24px",
              }}
            />
            <div className={style.reward_desc}>Amount</div>
          </div>
        </div>
      </div>
    );
  }

  function HeaderContent() {
    return(<>
      <Helmet>
        <title>Refer a Friend | Joybuy</title>
        <meta
          name="description"
          content="Refer a friend to Joybuy and earn rewards! Share the joy of free shipping and a delivery guarantee on all orders. Invite your friends to shop today!"
        />
      </Helmet>
      <div className={style.invite_header}>
        <div className={style.content_frame}>
          <div className={style.left_frame}>
            <CodeTipIcon />
            <div className={style.otherInfo}>Soft launch available in E, EC, N, NW, SE, SW, W, WC areas of London. Expansion coming soon!</div>
            <div className={style.expire_time}>
              {(isError || isClosed) ? "The activity has ended." : `Expires in ${activityData?.expireTime}`}
            </div>
          </div>
          <PolitelyIcon />
          {
            !isError && !isClosed && (
              <button className={style.invite_terms} onClick={onOpenTerms}>
                Terms
              </button>
            )
          }
        </div>
      </div>
    </>)
  }

  if(isError || isClosed){
    return (
      <div className={style.invite_politely}>
        <HeaderContent />
        <div className={style.activity_close}>
          <img src="https://st.joy-sourcing.com/website/other/inviteError.png" width={200} height={200} alt="close" />
          <div className={style.close_txt}>The event has ended. Check out other places.</div>
          {
            isError
            ?
            <button className={style.homepage_btn} onClick={()=>location.reload()}>Try again</button>
            :
            <button className={style.homepage_btn} onClick={()=>location.href="/"}>Homepage</button>
          }
        </div>
      </div>
    )
  }

  return (
    <div className={style.invite_politely}>
      {/* Headers */}
      <HeaderContent />
      {/* How to earn reward */}
      {isCodeType ? <EarnRewardCodeContent /> : <EarnRewardCommonContent />}
      {/* Your rewards */}
      {isCodeType ? <YourRewardCodeContent /> : <YourRewardCommonContent />}
      {/* Your reward details */}
      <RewardDetails
        isCodeType={isCodeType}
        activityId={activityData?.activityId}
        currency={currency}
        taskProcess={taskProcess}
        onInvitingCheck={checkActivity}
      />
      {/* Terms Dialog */}
      <TermsDialog
        open={openTerms}
        content={activityData?.activityTerms as string}
        closeFn={onCloseTerms}
      />
      {/* Gift Model */}
      <GiftModel open={openGift} closeFn={onCloseGift} data={giftData} currency={currency} />
      {/* Share Dialog */}
      <ShareDialog
        isCodeType={isCodeType}
        open={openShare}
        closeFn={onCloseShare}
        currency={currency}
        shareInfo={shareInfo}
      />
      {/* confirm share */}
      <ConfirmShareDialog
        open={openConfirmShare}
        closeFn={onCloseConfirmShare}
        confirmShareMsg={confirmShareMsg}
      />
    </div>
  );
}
